import {setupForms} from '@fl/cmsch-fe-library';

import {FormStates} from 'app/setup';

import {AsyncValidationSource} from './async-validation-source';

const {
    useForm: appUseForm,
    formHelpers: appFormHelpers,
    formsReducer: appFormsReducer,
} = setupForms<FormStates>();

/** Hook for binding typed application forms to the shared form library helpers. */
export const useForm = appUseForm;

/** Redux action creators and selectors for the application's typed form state map. */
export const formHelpers = appFormHelpers;

/** Reducer that stores the application's typed form state map. */
export const formsReducer = appFormsReducer;

/** Returns whether async validation may run for the current form state. */
export const canRunAsyncValidation = (
    syncErrors: object | null | undefined,
    source: AsyncValidationSource | undefined,
): boolean => Boolean(source && !(syncErrors && Object.prototype.hasOwnProperty.call(syncErrors, source)));

export const createAsyncValidationHandler = (
    validate: (source: AsyncValidationSource) => void,
    source: AsyncValidationSource,
): (() => void) => () => validate(source);
